const ApiService = Shopware.Classes.ApiService;

class TopdataLlmConnectApiService extends ApiService {
    constructor(httpClient, loginService) {
        super(httpClient, loginService, '', 'application/json');
        this.name = 'topdataLlmConnectApiService';
    }

    getProviderCatalog() {
        return this.httpClient
            .get(`${this.getApiBasePath()}/_action/tdlc/llm-provider/catalog`, {
                headers: this.getBasicHeaders(),
            })
            .then((response) => ApiService.handleResponse(response));
    }

    syncModels(providerId) {
        const path = providerId
            ? `/_action/tdlc/llm-provider/${providerId}/sync-models`
            : '/_action/tdlc/llm-provider/sync-models';

        return this.httpClient
            .post(`${this.getApiBasePath()}${path}`, {}, {
                headers: this.getBasicHeaders(),
            })
            .then((response) => ApiService.handleResponse(response));
    }
}

export default TopdataLlmConnectApiService;
